import { useState, useEffect } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import ModalComponent from 'components/common/ModalComponent';
import SelectComponent from 'components/common/SelectComponent';
import { generatePassword, formatRoleName, formatPermissionName } from 'utils';
import { useAuth } from 'auth/AuthContext';
import PropTypes from 'prop-types';

const UserModal = ({ isOpen, onClose, onSave, positionsRoles, permissionsList, selectedUser }) => {
  const { user } = useAuth();
  const [generatedPassword, setGeneratedPassword] = useState('');

  useEffect(() => {
    if (isOpen && !selectedUser) {
      setGeneratedPassword(generatePassword());
    }
  }, [isOpen, selectedUser]);

  if (!isOpen) return null;

  const visibleRoles =
    Number(user.roleId) === 1 ? positionsRoles : positionsRoles.filter(role => role.roleId !== 1);

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={selectedUser ? 'Update User Permissions' : 'New User Permissions'}
      initialData={{
        email: selectedUser?.email || '',
        roleId: selectedUser?.roleId || '',
        permissions: selectedUser?.permissions || [],
        password: selectedUser?.password || generatedPassword
        // firstName: selectedUser?.firstName || '',
        // lastName: selectedUser?.lastName || ''
      }}
      onSave={onSave}
    >
      {modalProps => {
        const { formData, handleChange } = modalProps;

        return (
          <div className="space-y-4">
            {/* <div className='flex flex-col md:flex-row gap-4'>
              <label className='flex-1 block text-sm font-medium text-gray-700'>
                First Name
                <input
                  type='text'
                  name='firstName'
                  value={formData.firstName}
                  onChange={handleChange}
                  className='w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:border-green-500 focus:ring focus:ring-green-200'
                />
              </label>
              <label className='flex-1 block text-sm font-medium text-gray-700'>
                Last Name
                <input
                  type='text'
                  name='lastName'
                  value={formData.lastName}
                  onChange={handleChange}
                  className='w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:border-green-500 focus:ring focus:ring-green-200'
                />
              </label>
            </div> */}

            <div className="flex flex-col md:flex-row gap-4 mt-4">
              <label className="flex-1 block text-sm font-medium text-gray-700">
                Email
                <input
                  type="text"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleChange}
                  disabled={!!selectedUser}
                  className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
                />
              </label>

              {!selectedUser && isOpen && (
                <label className="flex-1 block text-sm font-medium text-gray-700">
                  Password
                  <div className="flex items-center mt-1">
                    <input
                      type="text"
                      name="password"
                      value={formData.password || generatedPassword}
                      onChange={handleChange}
                      readOnly={process.env.NODE_ENV !== 'development'}
                      className="w-full p-2 border border-gray-300 rounded-lg shadow-sm bg-gray-100"
                    />
                    <button
                      type="button"
                      className="ml-2 px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200"
                      onClick={() => {
                        const newPassword = generatePassword();
                        handleChange({ target: { name: 'password', value: newPassword } });
                      }}
                    >
                      <ArrowPathIcon className="w-5 h-5 text-gray-500" />
                    </button>
                  </div>
                </label>
              )}
            </div>

            <label className="block text-sm font-medium text-gray-700">
              Position
              <SelectComponent name="roleId" value={formData.roleId} onChange={handleChange}>
                <option value="" disabled>
                  Select a Role
                </option>
                {visibleRoles.map(role => (
                  <option key={role.roleId} value={role.roleId}>
                    {formatRoleName(role.roleName)}
                  </option>
                ))}
              </SelectComponent>
            </label>

            <div className="my-6">
              <h3 className=" mt-6">Management Access</h3>
              <div className="grid grid-cols-3 gap-4 py-4 bg-white rounded-md">
                {permissionsList.map(permission => (
                  <label
                    key={permission.permissionId}
                    className="flex items-center space-x-2 text-sm text-gray-700"
                  >
                    <input
                      type="checkbox"
                      name={permission.permissionId}
                      checked={formData.permissions.includes(permission.permissionId)}
                      onChange={e => {
                        const updatedPermissions = e.target.checked
                          ? [...formData.permissions, permission.permissionId]
                          : formData.permissions.filter(id => id !== permission.permissionId);

                        handleChange({
                          target: { name: 'permissions', value: updatedPermissions }
                        });
                      }}
                      className="w-4 h-4 text-green-600 border-gray-300 rounded"
                    />
                    <span>{formatPermissionName(permission.name)}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        );
      }}
    </ModalComponent>
  );
};

UserModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  positionsRoles: PropTypes.arrayOf(PropTypes.object),
  permissionsList: PropTypes.arrayOf(PropTypes.object),
  selectedUser: PropTypes.object
};

export default UserModal;
